import React, { useEffect } from 'react';
import { motion } from 'framer-motion'; 
import '../Styles/About.css';

// Importing images
import photoImage1 from '../images/wordpress.webp';  
import photoImage2 from '../images/weblow.webp';  
import photoImage3 from '../images/html.png';  
import photoImage4 from '../images/css.png';  
import photoImage5 from '../images/figma.webp';  
import photoImage6 from '../images/seo.webp'; 
import photoImage7 from '../logo.svg'; 
import photoImage8 from '../images/nextjs.png';     
import photoImage9 from '../images/tailwind.png';  
import photoImage10 from '../images/adobe.png';  

function About() {
  useEffect(() => {
    // Optional side effects
  }, []);

  return (
    <div className="container">
      <div style={{ position: 'relative', height: '100vh', overflow: 'hidden' }}></div>

      {/* Skills Bars Section */}
      <div className="grid-container">
        {/* Existing skill blocks */}
        {[ 
          { img: photoImage1, label: 'WORDPRESS - 80%', height: '80vh', delay: 0 },
          { img: photoImage2, label: 'WEBFLOW - 50%', height: '60vh', delay: 0.2 },
          { img: photoImage3, label: 'HTML - 80%', height: '80vh', delay: 0.4 },
          { img: photoImage4, label: 'CSS - 90%', height: '90vh', delay: 0.6 },
          { img: photoImage5, label: 'FIGMA - 75%', height: '75vh', delay: 0.8 },
          { img: photoImage6, label: 'SEO - 70%', height: '70vh', delay: 1 },
          { img: photoImage7, label: 'REACT - 60%', height: '60vh', delay: 1.2 },
          { img: photoImage8, label: 'NEXT.JS - 50%', height: '60vh', delay: 1.4 },   
          { img: photoImage9, label: 'TAILWIND - 80%', height: '70vh', delay: 1.6 },
          { img: photoImage10, label: 'ADOBE XD - 75%', height: '75vh', delay: 1.8 },
        ].map(({ img, label, height, delay }, index) => (
          <motion.div
            key={index}
            className="grid-item"
            style={{ 
              background: 'linear-gradient(135deg,rgba(167,167,167,0.4),rgba(248,248,248,0.2))', 
              height 
            }}
            initial={{ opacity: 0, y: -100 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: 'easeOut', delay }}
          >
            <button className="test-btn">
              <img src={img} alt="icon" />
              {label}
            </button>
          </motion.div>
        ))}
      </div>

      <div className="about-me">
        <h2>About Me</h2>
        <p>
          Hello! I am a passionate web developer with experience in creating dynamic and responsive websites. 
          I specialize in front-end technologies like React, HTML, CSS, and WordPress, and I enjoy working with 
          modern tools like Webflow and Figma. I'm always eager to learn and enhance my skills.
        </p>
      </div>
    </div>
  );
}

export default About;
